import { Topic } from 'src/app/models/topic.model';

import { OBJECT_CONTENT } from 'src/app/data/contents/como-certificar/requisitos-certificacion/requisito-13/objetivo.data';
import { DESCRIPTION_CONTENT } from 'src/app/data/contents/como-certificar/requisitos-certificacion/requisito-13/description.data';
import { PROOFS_CONTENT } from 'src/app/data/contents/como-certificar/requisitos-certificacion/requisito-13/evidencias.data';
import { TOOLS_CONTENT } from 'src/app/data/contents/como-certificar/requisitos-certificacion/requisito-13/herramientas.data';
import { REQUISITO_NO_CRITICO } from 'src/app/data/contents/como-certificar/requisitos-certificacion/no-critico.data';
import { environment } from 'src/environments/environment';

export const REQUIREMENT_13_TOPIC: Topic = new Topic({
   idTopic: '997b13b355d98031e691adadf3e03713',
   order: 1,
   title: 'Requisito 13: Accesibilidad',
   subTopics: [
      
   ],
   contents: [
      REQUISITO_NO_CRITICO,
      OBJECT_CONTENT,
      DESCRIPTION_CONTENT,
      PROOFS_CONTENT,
      TOOLS_CONTENT
   ],
   primaryColor: environment.colors.first
});